import { useState } from 'react';
import SectionHeading from './SectionHeading';
import { faqList } from '@/mocks/faq';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="scroll-mt-16 bg-background-100 py-14 md:py-20 border-t border-background-200/70">
      <div className="px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionHeading
              icon="ri-question-line"
              eyebrow="常见问题"
              title="关于本站与内容的一些说明"
              desc="如果你第一次来到茶杯狐影视，下面几个问题可以帮助你快速理解页面的组织方式与使用方式。"
              tone="secondary"
            />
            <div className="mt-6 p-4 rounded-lg bg-background-50 border border-background-200">
              <p className="text-xs leading-6 text-foreground-600">
                提示：本页所有条目与说明均为内容展示，评分、集数等信息以能确认的范围呈现，不完整处保留一般性描述。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              {faqList.map((item, index) => {
                const isOpen = index === openIndex;
                return (
                  <div key={item.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? -1 : index)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer transition-colors hover:bg-primary-50"
                    >
                      <span className="flex items-center gap-3">
                        <span
                          className={`flex items-center justify-center w-6 h-6 shrink-0 rounded-md text-xs font-bold ${
                            isOpen ? 'bg-primary-500 text-background-50' : 'bg-primary-100 text-primary-700'
                          }`}
                        >
                          {index + 1}
                        </span>
                        <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                          {item.q}
                        </span>
                      </span>
                      <i
                        className={`shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${
                          isOpen ? 'ri-subtract-line' : 'ri-add-line'
                        }`}
                      ></i>
                    </button>
                    {isOpen && (
                      <div className="px-4 md:px-5 pb-5 pl-14 md:pl-14">
                        <p className="text-sm leading-7 text-foreground-600">{item.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}